/* src/app/components/controls/content-controls/sem-ai-assistant/sem-ai-assistant.component.css */
.ai-assistant-loading {
  opacity: 0.6;
  animation: ai-assistant-pulse 1.4s ease-in-out infinite;
}
@keyframes ai-assistant-pulse {
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
/*# sourceMappingURL=sem-ai-assistant.component.css.map */
